import { render } from "./LinkedObject.vue?vue&type=template&id=793a38c7&scoped=true"
import script from "./LinkedObject.vue?vue&type=script&lang=js"
export * from "./LinkedObject.vue?vue&type=script&lang=js"

import "./LinkedObject.vue?vue&type=style&index=0&id=793a38c7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793a38c7"]])

export default __exports__